import { create } from 'zustand';
import { TLE_ASSET_IDS } from './source';

export type OrbitView = 'spacecraft' | 'orbit' | 'footprint';
export interface OrbitReading {
  timeMs: number;
  epochMs: number;
  lat: number;
  lon: number;
  altKm: number;
  diameterKm: number;
  source: string;
  mode?: 'tle' | 'reference';
}

/** Presentation only. Ephemeris and time remain owned by the loader. */
export const useSatelliteOrbit = create<{
  view: OrbitView;
  beam: boolean;
  ready: boolean;
  error: string | null;
  reading: OrbitReading | null;
  resetSeq: number;
  setView: (view: OrbitView) => void;
  setBeam: (beam: boolean) => void;
  resetCamera: () => void;
}>((set) => ({
  view: 'spacecraft',
  beam: true,
  ready: false,
  error: null,
  reading: null,
  resetSeq: 0,
  setView: (view) => set((s) => ({ view, resetSeq: s.resetSeq + 1 })),
  setBeam: (beam) => set({ beam }),
  resetCamera: () => set((s) => ({ resetSeq: s.resetSeq + 1 })),
}));

export function isJasonAsset(asset: { elementId: string } | null): boolean {
  return asset?.elementId === 'senseSat_01' || asset?.elementId === 'noaa_reference:jason3';
}

export function isOrbitalAsset(asset: { elementId: string } | null): boolean {
  return !!asset && (asset.elementId in TLE_ASSET_IDS || ['goes', 'tdrs'].includes(asset.elementId));
}
